import { useNavigate } from 'react-router-dom';
import { Button, Card, Col, Layout, Row, Space, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { isMobileOnly } from 'react-device-detect';
import { BookEditIcon } from 'hugeicons-react';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;
export default function Help() {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<Layout style={{ padding: isMobileOnly ? 16 : '16px 40px', backgroundColor: '#F5F5F5' }}>
			<Button
				onClick={() => navigate(-1)}
				type="text"
				style={{ color: '#004799', fontSize: 16, width: 80, padding: 0 }}
				icon={<ArrowLeftOutlined />}>
				{t('viability.back')}
			</Button>
			<Card style={{ marginTop: 12, padding: isMobileOnly ? 16 : '24px 32px', borderRadius: 8 }}>
				<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
					<div
						style={{
							color: '#424242',
							fontSize: 16,
							fontWeight: 600,
							gap: 4,
							display: 'flex',
							alignItems: 'center'
						}}>
						<BookEditIcon style={{ color: '#424242' }} />
						{t('viability.doubts')}
					</div>
					<Text style={{ color: '#212121' }}>{t('consult.manual')}</Text>
					<div
						style={{
							borderRadius: 8,
							overflow: 'hidden',
							display: 'flex',
							maxWidth: 293,
							height: 188,
							boxShadow: '0 4px 4px 0 rgba(117, 117, 117, 0.15)'
						}}>
						<div
							style={{
								width: 108,
								background: 'url(/images/background-user-manual.png)',
								backgroundSize: 'cover',
								backgroundPosition: 'center',
								backgroundRepeat: 'none'
							}}
						/>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								gap: 8,
								padding: 16,
								background: '#F8F9FD'
							}}>
							<Text
								style={{
									color: '#212121',
									fontSize: isMobileOnly ? 14 : 16,
									fontWeight: 600,
									lineHeight: 1.2
								}}>
								{t('manual.user')} - {t('manual.client')}
							</Text>
							<Text style={{ color: '#424242', fontSize: isMobileOnly ? 11 : 12, maxWidth: 152 }}>
								{t('manual.learn')}
							</Text>
							<Button
								onClick={() =>
									window.open(
										'https://gibobs-dev-cdn.s3.eu-central-1.amazonaws.com/brands/sabadell-es/Manual_uso_cliente_SB.pdf',
										'_blank'
									)
								}
								style={{
									color: '#004799',
									borderColor: '#004799',
									maxWidth: 130,
									marginTop: 'auto',
									borderRadius: 8,
									height: 32,
									background: 'transparent'
								}}>
								{t('manual.read')}
							</Button>
						</div>
					</div>
				</div>
			</Card>
		</Layout>
	);
}
